<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">订单评价</div>
			<div class="right">
				<el-button size="mini" @click="refreshComment">
					<i class="el-icon-refresh"></i>
					<span>刷新</span>
				</el-button>
			</div>
		</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="8">
						<div class="box">
							<div class="label">评价查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入关键字" class="input-with-select"
									size="small" clearable>
									<el-select v-model="query.keytype" slot="prepend" placeholder="请选择">
										<el-option label="按订单编号" value="no"></el-option>
										<el-option label="按司机姓名" value="driver"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="9">
						<div class="box">
							<div class="label">评价时间：</div>
							<div class="input">
								<el-date-picker v-model="query.date" type="daterange" range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%;">
								</el-date-picker>
							</div>
						</div>
					</el-col>
					<el-col :span="7">
						<el-button type="primary" icon="el-icon-search" size="small" style="width: 6rem;"
							@click="searchComment">搜索
						</el-button>
						<el-button size="small" @click="resetSearchComment">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-list comment">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col width="8%">
						<col width="14%">
						<col width="10%">
						<col width="10%">
						<col>
						<col width="16%">
						<col width="10%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th style="text-align: center;padding-left: 0;">用户</th>
							<th>订单编号</th>
							<th>司机</th>
							<th>评分</th>
							<th>反馈内容</th>
							<th>评价时间</th>
							<th>操作</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col width="8%">
						<col width="14%">
						<col width="10%">
						<col width="10%">
						<col>
						<col width="16%">
						<col width="10%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="7"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox></el-checkbox>
									</div>
								</td>
								<td>
									<div class="head">
										<el-avatar v-if="item.head" shape="square" :size="40" :src="item.head">
										</el-avatar>
										<el-avatar v-else shape="square" :size="40"
											:src="require('@/assets/custom_head.png')">
										</el-avatar>
									</div>
								</td>
								<td>
									<div class="order">
										<div>{{item.order}}</div>
										<div class="link" @click="lookOrder(item.order)">查看</div>
									</div>
								</td>
								<td>
									<div class="driver">
										<div class="name">{{item.driver.name}}</div>
										<div class="score">{{item.driver.score}}</div>
									</div>
								</td>
								<td>
									<div class="score">
										<div>
											<span v-if="item.fen==1" style="color: red;">{{ item.score }}</span>
											<span v-else>{{ item.score }}</span>
										</div>
										<div class="fen">{{item.fen}}分</div>
									</div>
								</td>
								<td>
									<div class="content">
										{{item.content?item.content:"-"}}
									</div>
								</td>
								<td>
									<div class="time">{{item.time}}</div>
								</td>
								<td>
									<div class="operate">
										<el-button type="danger" plain size="mini" @click="delComment(index)"
											:loading="item.del_loading">
											删除
										</el-button>
									</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageComment">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无评价数据" :image-size="100">
			</el-empty>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: []
			};
		},
		created() {
			if (this.$route.params.query != undefined) {
				this.query = this.$route.params.query
			}
			this.pageComment(1);
		},
		methods: {
			searchComment() {
				const that = this;
				const query = Object.keys(that.query);
				if (query.length <= 0) {
					that.$message.error("错误：至少需要一个搜索项");
				} else {
					if (that.query.keyword && that.query.keytype == undefined) {
						that.$message.error("错误：请选择关键字类型");
						return;
					}
					if (that.query.keyword == undefined && that.query.keytype) {
						that.$message.error("错误：请输入搜索关键字");
						return;
					}
					that.pageComment(1);
				}
			},
			resetSearchComment() {
				this.query = {};
				this.postComment();
			},
			refreshComment() {
				this.pageComment(1);
			},
			lookOrder(order){
				this.$router.push({
					name: "order_list_all",
					params: {
						query: {
							keytype: "no",
							keyword: order
						}
					}
				});
			},
			delComment(index){
				const that = this;
				that.$confirm('删除后会重新计算总评分，是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.list[index].del_loading = true;
					that.$post('orderComment', {
						mode: "del",
						id: that.list[index].id
					}).then(res => {
						that.list[index].del_loading = false;
						that.$message.success("删除成功");
						setTimeout(function() {
							that.pageComment(1);
						}, 500);
					}).catch(e => {
						that.list[index].del_loading = false;
						that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
							"未知错误，请重试", '提示', {
								type: 'error',
								confirmButtonText: '确定'
							});
					});
				}).catch(() => {});
			},
			pageComment(e) {
				this.page = e;
				this.postComment(this.query);
			},
			postComment(query = {}) {
				const that = this;
				that.loading = true;
				that.$post('orderComment', {
					query: query,
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						res.data.list.map((item) => {
							item.checked = false;
							item.del_loading = false;
							return item;
						});
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.comment {
		font-size: 0.875rem;
	}

	.comment .head {
		padding: 0.625rem;
		text-align: center;
	}

	.comment .order,
	.comment .driver,
	.comment .score,
	.comment .content,
	.comment .time,
	.comment .operate {
		text-align: center;
	}

	.comment .order .link {
		font-size: 0.75rem;
		margin: 0;
		margin-top: 0.25rem;
	}

	.comment .driver .name {
		font-weight: bold;
		color: #576b95;
	}

	.comment .driver .score {
		color: #f60;
		font-size: 0.8125rem;
	}

	.comment .score .fen {
		font-size: 0.8125rem;
	}
</style>
